import React, { useState } from 'react';
import { Share2Icon, CheckIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ShareButtonProps {
  title: string;
  text: string;
}
export const ShareButton: React.FC<ShareButtonProps> = ({
  title,
  text
}) => {
  const [copied, setCopied] = useState(false);
  const handleShare = async () => {
    const shareText = `${title}\n\n${text}`;
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  return <button onClick={handleShare} className="inline-flex items-center space-x-2 text-sm text-gray-600 hover:text-[#1E90FF] transition-colors print:hidden" type="button" data-id="element-582">
      <AnimatePresence mode="wait" data-id="element-583">
        {copied ? <motion.div key="check" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} exit={{
        scale: 0
      }} className="flex items-center space-x-1" data-id="element-584">
            <CheckIcon className="h-4 w-4 text-green-600" data-id="element-585" />
            <span className="text-green-600" data-id="element-586">Copied!</span>
          </motion.div> : <motion.div key="share" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} exit={{
        scale: 0
      }} className="flex items-center space-x-1" data-id="element-587">
            <Share2Icon className="h-4 w-4" data-id="element-588" />
            <span data-id="element-589">Share</span>
          </motion.div>}
      </AnimatePresence>
    </button>;
};